'use client';

import { useState, useEffect } from 'react';

export function useScrollSpy(
  ids: string[],
  offset: number = 0
): string | null {
  const [activeId, setActiveId] = useState<string | null>(ids[0] || null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + offset + 1; // +1 to avoid being exactly at the boundary
      let currentActiveId: string | null = null;

      for (const id of ids) {
        const element = document.getElementById(id);
        if (element && element.offsetTop <= scrollPosition) {
          currentActiveId = id;
        } else {
          break; // Since ids are ordered, we can break early
        }
      }

      if (currentActiveId === null && ids.length > 0) {
        currentActiveId = ids[0];
      }

      setActiveId(currentActiveId);
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check

    return () => window.removeEventListener('scroll', handleScroll);
  }, [ids, offset]);

  return activeId;
}
